import axios from 'axios'
import {restore} from '@/config/store'
import authService from '@/services/security/hosted-auth.service'

const amioWebappHttpClient = axios.create({
  baseURL: `${process.env.VUE_APP_APP_SERVER_URL}/api/v1/`,
  headers: {'X-Requested-With': 'XMLHttpRequest'}
})

amioWebappHttpClient.interceptors.request.use(config => {
  config.headers['Authorization'] = `Bearer ${localStorage.access_token}`
  return config
})

amioWebappHttpClient.interceptors.response.use(function (response) {
  return response
}, function (error) {
  log.info(`unexpected http error occurred (${error})`, error.response, error.config)

  if (error.response.status === 401) {
    // access token probably expired. Logout user.
    authService.logout()
    restore()
    return Promise.resolve() // it avoids toast blinking while redirect to auth0 is in progress
  }

  return Promise.reject(error)
})

export default amioWebappHttpClient
